"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Nuvemshop = void 0;
var Nuvemshop = /** @class */ (function () {
    function Nuvemshop(window) {
        this.ADD_TO_CART_EVENT = 'cart.updated';
        this.ORDER_CREATED_EVENT = '';
        this.window = window;
    }
    /**
     * Transforming LS object cart into Cart
     */
    Nuvemshop.prototype.getCart = function () {
        var _a = this.window.LS.cart, items = _a.items, subtotal = _a.subtotal;
        return {
            id: '',
            currency: '',
            items: items.map(function (item) {
                return {
                    id: item.id,
                    quantity: item.quantity,
                    unitPrice: item.unit_price
                };
            }),
            subtotal: subtotal
        };
    };
    /**
     * Transforming LS object cart into Order
     * and decide if order is completed or not
     */
    Nuvemshop.prototype.getOrder = function () {
        var _a, _b;
        var order = this.window.LS.order;
        var customerID = this.window.LS.customer;
        var currency = this.window.LS.currency;
        var cart = this.window.LS.cart;
        if (!order) {
            return null;
        }
        return {
            currency: currency,
            customerID: customerID.toString(),
            id: order.number,
            isCompleted: true,
            subtotal: order.total / 100,
            coupon: (_a = order.coupon) === null || _a === void 0 ? void 0 : _a.code,
            phone: (_b = cart.contact) === null || _b === void 0 ? void 0 : _b.phone
        };
    };
    Nuvemshop.prototype.extractCartFromEvent = function (e) {
        var cart = e.detail;
        var id = cart.id, currency = cart.currency, products = cart.products;
        var totalPrice = 0;
        var items = products.map(function (product) {
            var productPrice = parseFloat(product.price);
            totalPrice = totalPrice + product.quantity * productPrice;
            return {
                id: product.id,
                quantity: product.quantity,
                unitPrice: parseFloat(product.price)
            };
        });
        return {
            id: id,
            currency: currency,
            items: items,
            subtotal: totalPrice
        };
    };
    Nuvemshop.prototype.extractOrderFromEvent = function () {
        return {
            isCompleted: false
        };
    };
    Nuvemshop.prototype.registerEvents = function (checkAndDispatchCartEvent) {
        this.window.addEventListener(this.ADD_TO_CART_EVENT, checkAndDispatchCartEvent);
    };
    return Nuvemshop;
}());
exports.Nuvemshop = Nuvemshop;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTnV2ZW1zaG9wLmpzIiwic291cmNlUm9vdCI6InNyYy8iLCJzb3VyY2VzIjpbInNyYy9saWIvc2VydmljZXMvZWNvbW1lcmNlL3BsYXRmb3Jtc01hbmFnZXJzL051dmVtc2hvcC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFRQTtJQU1JLG1CQUFZLE1BQXVCO1FBTG5DLHNCQUFpQixHQUFHLGNBQWMsQ0FBQTtRQUNsQyx3QkFBbUIsR0FBRyxFQUFFLENBQUE7UUFLcEIsSUFBSSxDQUFDLE1BQU0sR0FBRyxNQUFNLENBQUE7SUFDeEIsQ0FBQztJQUVEOztPQUVHO0lBQ0gsMkJBQU8sR0FBUDtRQUNVLElBQUEsS0FBcUMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxFQUFFLENBQUMsSUFBSSxFQUF0RCxLQUFLLFdBQUEsRUFBRSxRQUFRLGNBQXVDLENBQUE7UUFFOUQsT0FBTztZQUNILEVBQUUsRUFBRSxFQUFFO1lBQ04sUUFBUSxFQUFFLEVBQUU7WUFDWixLQUFLLEVBQUUsS0FBSyxDQUFDLEdBQUcsQ0FBQyxVQUFDLElBQXVCO2dCQUNyQyxPQUFPO29CQUNILEVBQUUsRUFBRSxJQUFJLENBQUMsRUFBRTtvQkFDWCxRQUFRLEVBQUUsSUFBSSxDQUFDLFFBQVE7b0JBQ3ZCLFNBQVMsRUFBRSxJQUFJLENBQUMsVUFBVTtpQkFDN0IsQ0FBQTtZQUNMLENBQUMsQ0FBQztZQUNGLFFBQVEsVUFBQTtTQUNYLENBQUE7SUFDTCxDQUFDO0lBRUQ7OztPQUdHO0lBQ0gsNEJBQVEsR0FBUjs7UUFDSSxJQUFNLEtBQUssR0FBbUIsSUFBSSxDQUFDLE1BQU0sQ0FBQyxFQUFFLENBQUMsS0FBSyxDQUFBO1FBQ2xELElBQU0sVUFBVSxHQUFHLElBQUksQ0FBQyxNQUFNLENBQUMsRUFBRSxDQUFDLFFBQVEsQ0FBQTtRQUMxQyxJQUFNLFFBQVEsR0FBRyxJQUFJLENBQUMsTUFBTSxDQUFDLEVBQUUsQ0FBQyxRQUFRLENBQUE7UUFDeEMsSUFBTSxJQUFJLEdBQWtCLElBQUksQ0FBQyxNQUFNLENBQUMsRUFBRSxDQUFDLElBQUksQ0FBQTtRQUMvQyxJQUFJLENBQUMsS0FBSyxFQUFFO1lBQ1IsT0FBTyxJQUFJLENBQUE7U0FDZDtRQUVELE9BQU87WUFDSCxRQUFRLEVBQUUsUUFBUTtZQUNsQixVQUFVLEVBQUUsVUFBVSxDQUFDLFFBQVEsRUFBRTtZQUNqQyxFQUFFLEVBQUUsS0FBSyxDQUFDLE1BQU07WUFDaEIsV0FBVyxFQUFFLElBQUk7WUFDakIsUUFBUSxFQUFFLEtBQUssQ0FBQyxLQUFLLEdBQUcsR0FBRztZQUMzQixNQUFNLEVBQUUsTUFBQSxLQUFLLENBQUMsTUFBTSwwQ0FBRSxJQUFJO1lBQzFCLEtBQUssRUFBRSxNQUFBLElBQUksQ0FBQyxPQUFPLDBDQUFFLEtBQUs7U0FDN0IsQ0FBQTtJQUNMLENBQUM7SUFFRCx3Q0FBb0IsR0FBcEIsVUFBcUIsQ0FBUTtRQUN6QixJQUFNLElBQUksR0FBSSxDQUFpQixDQUFDLE1BQWlDLENBQUE7UUFDekQsSUFBQSxFQUFFLEdBQXlCLElBQUksR0FBN0IsRUFBRSxRQUFRLEdBQWUsSUFBSSxTQUFuQixFQUFFLFFBQVEsR0FBSyxJQUFJLFNBQVQsQ0FBUztRQUV2QyxJQUFJLFVBQVUsR0FBRyxDQUFDLENBQUE7UUFDbEIsSUFBTSxLQUFLLEdBQUcsUUFBUSxDQUFDLEdBQUcsQ0FBQyxVQUFDLE9BQU87WUFDL0IsSUFBTSxZQUFZLEdBQUcsVUFBVSxDQUFDLE9BQU8sQ0FBQyxLQUFLLENBQUMsQ0FBQTtZQUM5QyxVQUFVLEdBQUcsVUFBVSxHQUFHLE9BQU8sQ0FBQyxRQUFRLEdBQUcsWUFBWSxDQUFBO1lBRXpELE9BQU87Z0JBQ0gsRUFBRSxFQUFFLE9BQU8sQ0FBQyxFQUFFO2dCQUNkLFFBQVEsRUFBRSxPQUFPLENBQUMsUUFBUTtnQkFDMUIsU0FBUyxFQUFFLFVBQVUsQ0FBQyxPQUFPLENBQUMsS0FBSyxDQUFDO2FBQ3ZDLENBQUE7UUFDTCxDQUFDLENBQUMsQ0FBQTtRQUVGLE9BQU87WUFDSCxFQUFFLElBQUE7WUFDRixRQUFRLFVBQUE7WUFDUixLQUFLLE9BQUE7WUFDTCxRQUFRLEVBQUUsVUFBVTtTQUN2QixDQUFBO0lBQ0wsQ0FBQztJQUVELHlDQUFxQixHQUFyQjtRQUNJLE9BQU87WUFDSCxXQUFXLEVBQUUsS0FBSztTQUNyQixDQUFBO0lBQ0wsQ0FBQztJQUVELGtDQUFjLEdBQWQsVUFBZSx5QkFBd0Q7UUFDbkUsSUFBSSxDQUFDLE1BQU0sQ0FBQyxnQkFBZ0IsQ0FBQyxJQUFJLENBQUMsaUJBQWlCLEVBQUUseUJBQXlCLENBQUMsQ0FBQTtJQUNuRixDQUFDO0lBQ0wsZ0JBQUM7QUFBRCxDQUFDLEFBdkZELElBdUZDO0FBdkZZLDhCQUFTIn0=